/*
 * SurveyPage
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Paper from 'material-ui/Paper';
import Button from '../../components/Buttons';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import { updateSurveyStatus } from '../../modules/student';
import AutoCompleteInput from '../../components/Form/AutoCompleteInput';
import ErrorBoundary from '../../components/ErrorBoundary';
import isBoolean from 'lodash/isBoolean';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import './SurveyPage.css';
import StudentApi from '../../helper/StudentApi';

class SurveyPage extends Component {
    static propTypes = {
        updateSurveyStatus: PropTypes.func.isRequired,
        studentSrn: PropTypes.number,
        birthday: PropTypes.string,
        age: PropTypes.number,
    };

    state = {
        isParticipate: null,
        isFirstTime: null,
        numBooksLastYear: '',
        schoolInput: '',
        participatedYear: '',
        numBookPreviousChoose: '',
        suggestions: [],
        selectedSchool: {},
        schoolList: [],
    }

    boolQuestionHandler = (name, value) => {
        this.setState({[name]: value})
    }

    selectQuestionHandler = name => event => {
        this.setState({ [name]: event.target.value });
    }

    getButtonColor = (name, isYesButton) => {
        if (isBoolean(this.state[name])) {
            const value = isYesButton ? this.state[name] : !this.state[name]
            return value ? "primary" : "secondary"
        } else {
            return "secondary"
        }
    }

    renderFirstTimeQuestions = () => {
        return  <div className="survey__form--questios">
                    <p>There are two conditions of entry for the Challenge:</p>
                    <p>1. Students may receive a certificate which displays the student’s name and school name.</p>
                    <p>How many books did you read last year</p>
                    <Select
                        native
                        disableUnderline
                        MenuProps={{
                            tabIndex: 0
                        }}
                        className="survey__form--select"
                        value={this.state['numBooksLastYear']}
                        onChange={this.selectQuestionHandler('numBooksLastYear')}>
                        <option value="0">None</option>
                        <option value={10}>Ten</option>
                        <option value={20}>Twenty</option>
                        <option value={30}>Thirty</option>
                    </Select>
                </div>
    }

    handleSchoolInputChange = (value) => {
        this.setState({ schoolInput: value })
    }

    getSuggestionValue = (school) => {
        this.setState({ selectedSchool: school })
        return school.schoolName;
    }

    fetchSchoolList = () => {
        if (this.state.schoolList && this.state.schoolList.length) {
            return Promise.resolve(this.state.schoolList);
        }
        return StudentApi.fetchSchoolList()
            .then(r => {
                this.setState({schoolList: r.schools});
                return r.schools;
            });
    }

    fetchSuggestions = debounce((value) => {
        const inputValue = value.trim().toLowerCase();
        this.fetchSchoolList().then((r) => {
            const result = r.filter((school) => school.schoolName.toLowerCase().includes(inputValue));
            this.setState({
                suggestions: result.slice(0, Math.min(result.length, 20)),
            });
        })
    }, 250)

    renderSuggestionOptions = (suggestion) => {
        return (
            <MenuItem component="div" className="autoComplete__list">
                <div className="autoComplete__list--content">
                    <p>{suggestion.schoolName}</p>
                </div>
            </MenuItem>
        )
    }

    renderQuestions = () => {
        const {
            schoolInput,
            suggestions,
        } = this.state;
        return  <div className="survey__form--questios">
                    <p>Which school did you attend when you last took part in the challenge?</p>
                    <div>
                        <AutoCompleteInput
                            inputValue={schoolInput}
                            handleInputChange={this.handleSchoolInputChange}
                            inputPlaceHolder="Type here..."
                            getSuggestions={this.fetchSuggestions}
                            suggestions={suggestions}
                            getSuggestionValue={this.getSuggestionValue}
                            renderSuggestion={this.renderSuggestionOptions}
                        />
                    </div>

                    <p>Which year did you last take part in the Challenge?</p>
                    <Select
                        native
                        disableUnderline
                        MenuProps={{
                            tabIndex: 0
                        }}
                        className="survey__form--select"
                        value={this.state['participatedYear']}
                        onChange={this.selectQuestionHandler('participatedYear')}>
                        <option value={-1}>Select</option>
                        <option value={0}>None</option>
                        <option value={2017}>2017</option>
                        <option value={2018}>2018</option>
                        <option value={2019}>2019</option>
                        <option value={2020}>2020</option>
                        <option value={2021}>2021</option>
                        <option value={2022}>2022</option>
                        <option value={2023}>2023</option>
                        <option value={2024}>2024</option>
                        <option value={2025}>2025</option>
                    </Select>

                    <p>In the year before you did the Challenge, how many books did you choose to read?</p>
                    <Select
                        native
                        disableUnderline
                        MenuProps={{
                            tabIndex: 0
                        }}
                        className="survey__form--select"
                        value={this.state['numBookPreviousChoose']}
                        onChange={this.selectQuestionHandler('numBookPreviousChoose')}>
                        <option value={-1}>Select</option>
                        <option value={0}>None</option>
                        <option value={10}>Ten</option>
                        <option value={20}>Twenty</option>
                        <option value={30}>Thirty</option>
                    </Select>
                </div>
    }

    renderSurvey = () => {
        return <div>
                    <div>
                        <p>Are you taking part in the Premier's Reading Challenge for the first time?</p>
                        <div className="form__buttonGroup--wrapper">
                            <Button variant="raised"
                                    onClick={() => this.boolQuestionHandler('isFirstTime', true)}
                                    color={this.getButtonColor('isFirstTime', true)}>Yes</Button>
                            <Button variant="raised"
                                    onClick={() => this.boolQuestionHandler('isFirstTime', false)}
                                    color={this.getButtonColor('isFirstTime', false)}>No</Button>
                        </div>
                    </div>
                    {this.state.isFirstTime === null? null :
                        (this.state.isFirstTime? this.renderFirstTimeQuestions() : this.renderQuestions())}
                </div>
    }

    isDisableSubmit = () => {
        const {
            isParticipate,
            isFirstTime,
            numBooksLastYear,
            participatedYear,
            schoolInput,
            numBookPreviousChoose,
        } = this.state;
        if(isParticipate === false) {
            return false
        }
        if(isParticipate === true && isFirstTime === true ){
            return false
        }
        if(isParticipate === true
            && isFirstTime === false
            && participatedYear
            && schoolInput){
            return false
        }
        return true
    }

    handleSurveySubmit = () => {
        const {
            participatedYear,
            selectedSchool,
            isParticipate,
            isFirstTime,
        } = this.state;
        const {
            studentSrn
        } = this.props;
        let body = {
            takingPartThisYear: isParticipate,
        }
        if (isParticipate && !isFirstTime) {
           body = {
               ...body,
               participatedYear,
               srn: studentSrn,
               prevSchoolID: selectedSchool.schoolId,
           }
        }
        StudentApi.submitStudentSurvey(body).then(
            () => this.props.updateSurveyStatus('0')
        ) // TODO: catch error
    }

    render () {
        return (
            <div className="app__survey">
                <ErrorBoundary>
                <Helmet>
                    <title>Survey Page</title>
                    <meta name="description" content="Survey page"/>
                </Helmet>
                <Paper>
                    <div className="survey__welcomeMessage">
                        <h2>2026 Reader Survey</h2>
                        <h3>Welcome to the Premier's Reading Challenge Survey. Please take a moment to answer the
                            following questions. Thank you for your help</h3>
                    </div>
                </Paper>

                <div className="survey__form--wrapper">
                    <p>Do you intend to take part in the 2026 Premier's Reading Challenge?</p>
                    <div className="form__buttonGroup--wrapper">
                        <Button variant="raised"
                                onClick={() => this.boolQuestionHandler('isParticipate', true)}
                                color={this.getButtonColor('isParticipate', true)}>Yes</Button>
                        <Button variant="raised"
                                onClick={() => this.boolQuestionHandler('isParticipate', false)}
                                color={this.getButtonColor('isParticipate', false)}>No</Button>
                    </div>
                    {this.state.isParticipate? this.renderSurvey() : null}
                </div>
                <div className="survey__button--wrapper">
                    <Button
                        aria-label="Submit survey form"
                        disabled={this.isDisableSubmit()}
                        className="survey__submitButton"
                        onClick={() =>this.handleSurveySubmit()}
                        variant="raised"
                        color="primary">
                        Finish
                    </Button>
                </div>
                </ErrorBoundary>
            </div>
        );
    }
}


const mapDispatchToProps = dispatch => bindActionCreators({
    updateSurveyStatus,
}, dispatch);

const mapStateToProps = state => ({
    studentSrn: get(state, 'student.studentDetails.srn'),
    birthday: get(state, 'student.studentDetails.birthday'),
    age: get(state, 'student.studentDetails.age'),
})

// withRouter needed because of Hash history
export default connect(mapStateToProps, mapDispatchToProps)(SurveyPage);
